import { render, staticRenderFns } from "./SmsTemplateList.vue?vue&type=template&id=06671905&scoped=true&"
import script from "./SmsTemplateList.vue?vue&type=script&lang=ts&"
export * from "./SmsTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./SmsTemplateList.vue?vue&type=style&index=0&id=06671905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06671905",
  null
  
)

export default component.exports